import { render, staticRenderFns } from "./casherProduct.vue?vue&type=template&id=cf66c870"
import script from "./casherProduct.vue?vue&type=script&lang=js"
export * from "./casherProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports